export const MESSAGE_EVENTS = {
  /** Sent by the chatbot app → parent SDK once the app is mounted and ready */
  CHATBOT_READY: 'CHATBOT_READY',
  /** Sent by the parent SDK → chatbot app carrying the auth object */
  CHATBOT_AUTH: 'CHATBOT_AUTH',
} as const;
